export default "__VITE_PUBLIC_ASSET__3869258b__"